import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetFinanceAgreementsByFundraisingId = (
  fundraisingId,
  groupId,
) => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    queryKey: [
      QUERY_KEYS.loan.finance_agreements_by_fundraising_id,
      fundraisingId,
      groupId,
    ],
    queryFn: () =>
      loanService
        .financeAgreementsByFundraisingId(fundraisingId, { group: groupId })
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            return data;
          }
          throw new Error('Fetch failed');
        }),
  });
};
